import React, { useState, useEffect } from 'react';
import './EmailFormDE.css';
import { offerClickBase } from '../../../constants';
import Loader from '../../../components/Loader/Loader';

const EmailFormDE = ({ picURL, pageType, campaignName, translations }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(null);

  const isValidEmail = (email) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email);
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    
    if (!isValidEmail(email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein');
      setSuccess(null);
      return;
    }

    setError(null);
    setSuccess(true);
    setLoading(true);

    // Store email in localStorage
    window.localStorage.setItem('S&R-DE', email);

    // Redirect after a delay
    setTimeout(() => {
      window.location.replace(`${offerClickBase()}&event1=${email}&sub4=de`);
    }, 700);
  };

  return (
    <div className="whole-form">
      <div>
        <div className="email-form-container">
          <form autoComplete="on" className="email-form">
            <label className="email-label" htmlFor="email">
              Geben Sie Ihre E-Mail-Adresse ein{' '}
              <span className="not-success"></span>
            </label>
            <div>
              <input
                id="email-input"
                name="email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              <span className="not-success"></span>
              <br />
              {error && (
                <>
                  <small style={{ color: 'rgb(178, 34, 34)' }}>
                    {error}
                    <span className="not-success"></span>
                  </small>
                  <br />
                </>
              )}
            </div>
          </form>
        </div>
        <br />
        <div>
          {loading ? (
            <div className="loading-container">
              <Loader width="3em" height="3em" />
            </div>
          ) : success ? (
            <div className="success-message">E-Mail erfolgreich verifiziert!</div>
          ) : (
            <button 
              className="rewards-btn-getit" 
              style={{ opacity: 0.85 }}
              onClick={handleSubmit}
            >
              WEITER 👉
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailFormDE;
